//action types
export const FORGOT_PASSWORD = 'LOGINFORGOT_PASSWORD';
export const FORGOT_PASSWORD_RESULT = 'FORGOT_PASSWORD_RESULT';

export const FORGOT_PASSWORD_CONFIRM_CLOSE = 'FORGOT_PASSWORD_CONFIRM_CLOSE';
export const FORGOT_PASSWORD_CONFIRM = 'FORGOT_PASSWORD_CONFIRM';
export const FORGOT_PASSWORD_CONFIRM_RESULT = 'FORGOT_PASSWORD_CONFIRM_RESULT';
